import React from 'react';
import {
    shiftKindKey,
    shiftTimes,
    shiftHours,
    minutesToTime,
    SHIFT_KINDS,
} from '../utils';

const kindByKey = SHIFT_KINDS.reduce((acc, item) => {
    acc[item.key] = item;
    return acc;
}, {});

const ScheduleCell = ({ shift, dimmed, onClick }) => {
    if (!shift) {
        return (
            <button type="button" className="pc-sched-plus" onClick={(event) => { event.stopPropagation(); onClick && onClick(event); }}>+</button>
        );
    }

    const key = shiftKindKey(shift);
    const { start, end } = shiftTimes(shift);
    const hours = shiftHours(shift);
    const kind = kindByKey[key] || kindByKey.d;
    const className = `pc-sched-sh pc-sched-sh-${key}${dimmed ? ' pc-sched-dim' : ''}`;

    let inner;
    if (key === 's') {
        inner = <span className="t">Больничный</span>;
    } else if (key === 'p') {
        inner = <span className="t">Прогул</span>;
    } else if (key === 'c') {
        inner = (
            <>
                <span className="t">{minutesToTime(start)} – {minutesToTime(end)}</span>
                <span className="d">отмена</span>
            </>
        );
    } else {
        inner = (
            <>
                <span className="t">{minutesToTime(start)} – {minutesToTime(end)}</span>
                <span className="d">{kind.n.toLowerCase()} · {hours} ч</span>
            </>
        );
    }

    return (
        <button type="button" className={className} onClick={(event) => { event.stopPropagation(); onClick && onClick(event); }}>
            {inner}
        </button>
    );
};

export default ScheduleCell;
